import styled from "styled-components"
import {H2, H3, H4} from "@irati/ui/src//Typography/Heading"
import media from "@irati/ui/src/global/media"
import {breakWord} from "@irati/ui/src/global/helpers"
import BrandAvatar from "@irati/ui/src/BrandAvatar"
import {Modal} from "react-bootstrap"
import {Label3} from "@irati/ui/src/Labels"
import {greys} from "@irati/ui/src/global/colors"
import Link from "@irati/ui/src/Link"
import {Dosis} from "@irati/ui/src/global/fonts"

export const InstructionHeader = styled(H4)`
  padding-bottom: 25px;
  font-weight: bold;
  ${media.tablet`
    font-family: Lato, sans-serif;
    font-weight: 400;
    font-size: 15px;
    padding-bottom: 15px;
  `}
`

export const StyledCopy = styled.div`
  padding: 10px 40px 10px 40px;
  ${media.tablet`
    padding: 10px 20px 10px 20px;
  `}
`

export const CodeWrapper = styled.div`
  margin-top: 20px;
`

export const QRCodeWrapper = styled.div`
  margin: 40px 0 20px 0;
  display: flex;
  justify-content: center;
  align-content: center;
`

export const StyledInstructions = styled.div`
  text-align: left;
`

export const CustomCreditInstructions = styled.div`
  padding: 20px 0;
`

export const Title = styled(H2)`
  padding-bottom: 15px;
  overflow-wrap: break-word;
  ${breakWord};
  ${media.tablet`
    font-size: 30px;
    line-height: 40px;
    padding-top: 20px;
    padding-bottom: 10px;
  `}
`

export const SubTitle = styled(H3)`
  padding-bottom: 35px;
  overflow-wrap: break-word;
  ${breakWord};
  ${media.tablet`
    padding-bottom: 25px;
  `}
`

export const Message = styled(H4)`
  padding-bottom: 25px;
  overflow-wrap: break-word;
  ${breakWord};
  ${media.tablet`
    padding-bottom: 15px;
  `}
`

export const HeaderWrapper = styled.div`
  margin: 0;
  padding-bottom: 20px;
  border-bottom: 1px dashed ${greys.dark};
`

export const ProductCode = styled.div`
  font-size: 28px;
  line-height: 35px;
  font-family: ${Dosis};
  margin-bottom: 10px;
  ${breakWord}
`

export const RewardAvatar = styled(BrandAvatar)`
  position: absolute;
  top: -${({theme}) => theme.spacing.eight};
  left: 50%;
  transform: translate3d(-50%, 0, 0);
`

export const StyledModal = styled(Modal)`
  padding-top: 100px;
  text-align: center;
  .modal-content {
    box-shadow: none;
    padding: 80px 20px 30px 20px;
    border: 1px solid ${greys.light};
    @media (max-width: 768px) {
      padding: 70px 30px 30px;
    }
  }
`

export const Label = styled(Label3)`
  color: ${greys.mediumDark};
  text-transform: uppercase;
`

export const Value = styled.span`
  margin-left: 10px;
  text-transform: uppercase;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.6px;
  color: ${greys.mediumDark};
`

export const StyledLink = styled(Link)`
  font-size: 28px;
  font-family: ${Dosis};
  word-break: break-word;
  display: block;
  text-align: center;
  padding: 10px 0 15px 0;
`
